<template>
    <TimeFilterContainer
        :filters="filters"
    />
</template>

<script>
    import { TimeFilter } from '@shared/timeFilter/enums';
    import TimeFilterContainer from '@src/terminal/app/modules/shared/timeFilter/TimeFilterContainer';
    import {
        getTimeFilterForWeekDay,
    } from '@shared/timeFilter/helpers';

    export default {
        name: 'SpecialTimeFilterContainer',
        created() {
            this.filters = [{
                id: TimeFilter.upcoming,
                isUppercase: true,
            }, {
                id: TimeFilter.today,
                isUppercase: true,
            }];
            const todayDayIndex = new Date().getDay();
            for (let i = todayDayIndex + 1; i < todayDayIndex + 7; i += 1) {
                this.filters.push({
                    id: getTimeFilterForWeekDay((i + 7) % 7),
                });
            }
            this.filters.push({
                id: TimeFilter.all,
                isUppercase: true,
            });
        },
        components: {
            TimeFilterContainer,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/specialOffer/timeFilter/SpecialTimeFilterContainer.vue